const Scroll = {
    to: (x, y) => {
        window.scrollTo(x, y);
    },
    toId: (id) => {
        let target = document.getElementById(id);
        if (target) {
            target.style.scrollMargin = '64px';
            target.scrollIntoView({ behavior: 'smooth' });
        }
    },
};
export default Scroll;
